import RequestSummaryResourceModel from '../../generated/types/model/resource/RequestSummaryResourceModel';

export default class RequestSummaryResourceViewModel extends RequestSummaryResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
